// Conformité — 5 KPIs cards (Dossiers actifs / Prime ANAH / Devis total /
// Reste à charge / Dépôts ANAH).
import {
  FileCheck, Banknote, TrendingUp, AlertTriangle, ShieldCheck, Loader2,
} from "lucide-react";
import { useConformiteFetch, fmtEuro } from "./useConformiteFetch";

function Kpi({ title, value, icon: Icon, accent, subtitle }) {
  return (
    <div
      className="rounded-xl p-4"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid={`conformite-kpi-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs mb-1" style={{ color: "var(--oh-text-muted)" }}>{title}</p>
          <p className="text-2xl font-bold truncate" style={{ color: "var(--oh-text)" }}>{value}</p>
          {subtitle && (
            <p className="text-[11px] mt-1 truncate" style={{ color: "var(--oh-text-secondary)" }}>{subtitle}</p>
          )}
        </div>
        <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: `${accent}20` }}>
          <Icon className="w-4 h-4" style={{ color: accent }} />
        </div>
      </div>
    </div>
  );
}

export default function ConformiteKpisWidget() {
  const { data, loading, error } = useConformiteFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Conformité KPIs : {error}
      </div>
    );
  }

  const t = data?.totaux || {};

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <Kpi
        title="Dossiers actifs" value={t.dossiers_actifs || 0} icon={FileCheck}
        accent="var(--oh-stat-blue-text)"
        subtitle={`sur ${t.dossiers || 0} dossiers`}
      />
      <Kpi
        title="Prime ANAH totale" value={fmtEuro(t.montant_prime_total)} icon={Banknote}
        accent="#10b981"
        subtitle="Montant subventions"
      />
      <Kpi
        title="Devis total" value={fmtEuro(t.montant_devis_total)} icon={TrendingUp}
        accent="#8b5cf6"
        subtitle="Travaux validés"
      />
      <Kpi
        title="Reste à charge" value={fmtEuro(t.reste_charge_total)} icon={AlertTriangle}
        accent="var(--oh-stat-amber-text)"
        subtitle="À la charge des clients"
      />
      <Kpi
        title="Dépôts ANAH" value={t.avec_date_depot || 0} icon={ShieldCheck}
        accent="var(--oh-stat-cyan-text)"
        subtitle={`${t.avec_date_octroi || 0} avec octroi`}
      />
    </div>
  );
}
